export const MINIMUM_SEARCH_QUERY_LENGTH = 3;
